import React from 'react';
import { Snackbar, Alert } from '@mui/material';

const SnackbarMessage = ({ snackbar, setSnackbar }) => (
  <Snackbar
    open={snackbar.open}
    autoHideDuration={3000}
    onClose={() => setSnackbar({ ...snackbar, open: false })}
  >
    <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
  </Snackbar>
);

export default SnackbarMessage;
